import React from "react";

import ReactHelmet from "../../components/react-helmet/react-helmet";
const Arizonaheader = () => {
  return (
    <>
      <ReactHelmet
        title={"Facilities For Sober Living in Arizona | Taste Recovery"}
        description={
          "Browse available facilities for sober living in Arizona offering safe, peer-reviewed & supportive environments to help individuals maintain lasting recovery."
        }
      />
    </>
  );
};

export default Arizonaheader;
